import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import type { Person } from '../../model/types.tsx';
import fetch, { type Response } from '../../rest/load-user/index.tsx';
import { getBaseUrl } from '../../state/selectors/app/index.tsx';
import type { MiddlewareAPI } from '../../state/types.tsx';

export const transformer = (response: Response): Person => ({
	id: response.accountId,
	displayName: response.displayName,
	avatarUrl: response.avatarUrls['48x48'],
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (store: MiddlewareAPI, accountId: string): ObservableType<Person> => {
	const state = store.getState();
	const baseUrl = getBaseUrl(state);

	return fetch(baseUrl, accountId).map(transformer);
};
